export default __webpack_public_path__ + "static/live_video@2x-6abf3068486963670f59929fc2fa19f9.png";